import { forwardRef, useImperativeHandle, useRef } from 'react';

import DateSegment from '../date-segment/date-segment';

import type { ForwardedRef, ReactElement } from 'react';

import type { DateSegmentsProps, DateSegmentsRef } from './date-segments.types';

/**
 * The `DateSegments` component is used to render the segments of a date input.
 *
 * @internal
 */
const DateSegments = forwardRef(
  ({ state }: DateSegmentsProps, segmentRefs: ForwardedRef<DateSegmentsRef>): ReactElement => {
    const refs = useRef<(HTMLElement | null)[]>([]);

    useImperativeHandle(segmentRefs, () => ({
      focusFirstSegment: () => {
        refs.current[0]?.focus();
      },
    }));

    return (
      <>
        {state.segments.map((segment, i) => (
          <DateSegment
            // eslint-disable-next-line react/no-array-index-key
            key={i} // NOSONAR
            ref={(el) => {
              refs.current[i] = el;
            }}
            segment={segment}
            state={state}
          />
        ))}
      </>
    );
  },
);

DateSegments.displayName = 'DateSegments';

export default DateSegments;
